var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./PerspectiveArticlesListInner.jinja');
require('./PerspectiveArticlesListInner.less');

module.exports = Base.extend({

    template: template,

    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PerspectiveArticlesList/PerspectiveArticlesListInner.js
// module id = 235
// module chunks = 0